import React, {Component} from "react";
import {Button, Modal, Table} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import { Row, Col } from 'antd';
import {getFacturationStatistics} from "../../../actions/thunks.js";
import {resetDocumentsFilters} from "../../../actions/actions.js";
import Piechart from "./PieChart";
import {formatAmount} from "utils";
import { Link,  browserHistory} from 'react-router';
import moment from "moment";
import { TTP_HOME_URL, TTP_PAYMENT_URL } from 'Config';
import UnpaidInvoicesDetails from "./UnpaidInvoicesDetails";
import DocumentsToBeExportedEfffZipDetails
  from "./DocumentsToBeExportedEfffZipDetails";



class FacturationStatisticsBloc extends Component {

  constructor(props) {
    super(props);

    this.state = {

      discr : null,
      visible: false,
      showSpinner : false,
    };
  }

  handleCancel = e => {
    this.setState({
      visible: false,
      discr : null
    });
    this.setState({showSpinner: false});
  };

  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getFacturationStatistics(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.eventStatsFilter.year && this.props.eventStatsFilter.year.length > 0 ? this.props.eventStatsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }

  componentDidUpdate(prevProps, prevState)
  {
    if(prevProps.statisticsFilter !== this.props.statisticsFilter || prevProps.eventStatsFilter.year !== this.props.eventStatsFilter.year) {
      this.props.getFacturationStatistics(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.eventStatsFilter.year && this.props.eventStatsFilter.year.length > 0 ? this.props.eventStatsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }

  getEventDates = () => {

    let result = [];

    if(this.props.statisticsFilter && this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length >0) {

      this.props.statisticsFilter.appRefs.forEach(id => {

        if (this.props.appRef && this.props.appRef.length > 0) {
          let appRefFilter = this.props.appRef.find(item => item.id == id);
          if (appRefFilter) {
            result.push(moment(appRefFilter.eventDate.date).format('YYYY'))
          }
        }
      });
    }

    return result;
  }


  showModal = (discriminant) => {
    this.setState({
      visible: true,
      discr : discriminant
    });
  };

  render() {
    const {facturationInfos } = this.props;
    let totalInvoices = 0;
    let totalCreditNote = 0;
    let totalOrder = 0;
    let totalCanceledOrder = 0;
    let totalValidOrder = 0;
    let caHorsTva = 0;
    let caTva = 0;
    let caTvaInclu = 0;
    let orderAmount = 0;
    let invoiceAmount = 0;
    let creditNoteAmount = 0;

    if(facturationInfos && facturationInfos.items && (facturationInfos.items['order'] || facturationInfos.items['invoice'] || facturationInfos.items['credit_note'])){

      totalOrder= (facturationInfos.items['order'] && facturationInfos.items['order']['NOT_PAID'] ? parseInt(facturationInfos.items['order']['NOT_PAID'].count) : 0) + (facturationInfos.items['order'] && facturationInfos.items['order']['PAID'] ? parseInt(facturationInfos.items['order']['PAID'].count) : 0)+ (facturationInfos.items['order'] && facturationInfos.items['order']['OVER_PAID'] ? parseInt(facturationInfos.items['order']['OVER_PAID'].count) : 0) + (facturationInfos.items['order'] && facturationInfos.items['order']['UNDER_PAID'] ? parseInt(facturationInfos.items['order']['UNDER_PAID'].count) : 0)
      totalInvoices= (facturationInfos.items['invoice'] && facturationInfos.items['invoice']['PAID'] ? parseInt(facturationInfos.items['invoice']['PAID'].count) : 0) + (facturationInfos.items['invoice'] && facturationInfos.items['invoice']['OVER_PAID'] ? parseInt(facturationInfos.items['invoice']['OVER_PAID'].count) : 0)+(facturationInfos.items['invoice'] && facturationInfos.items['invoice']['NOT_PAID'] ? parseInt(facturationInfos.items['invoice']['NOT_PAID'].count) : 0);
      totalCreditNote= (facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['REFUNDED'] ? parseInt(facturationInfos.items['credit_note']['REFUNDED'].count) : 0)+(facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['NOT_REFUNDED'] ? parseInt(facturationInfos.items['credit_note']['NOT_REFUNDED'].count) : 0);
      totalCanceledOrder = facturationInfos.items['1'] && facturationInfos.items['1'].count;
      totalValidOrder = facturationInfos.items['0'] && facturationInfos.items['0'].count;


      orderAmount = (facturationInfos.items['order'] && facturationInfos.items['order']['NOT_PAID'] ? parseInt(facturationInfos.items['order']['NOT_PAID'].including_vat_amount) : 0) + (facturationInfos.items['order'] && facturationInfos.items['order']['PAID'] ? parseInt(facturationInfos.items['order']['PAID'].including_vat_amount) : 0)+ (facturationInfos.items['order'] && facturationInfos.items['order']['OVER_PAID'] ? parseInt(facturationInfos.items['order']['OVER_PAID'].including_vat_amount) : 0) + (facturationInfos.items['order'] && facturationInfos.items['order']['UNDER_PAID'] ? parseInt(facturationInfos.items['order']['UNDER_PAID'].including_vat_amount) : 0)
      invoiceAmount = (facturationInfos.items['invoice'] && facturationInfos.items['invoice']['PAID'] ? parseInt(facturationInfos.items['invoice']['PAID'].including_vat_amount) : 0) + (facturationInfos.items['invoice'] && facturationInfos.items['invoice']['OVER_PAID'] ? parseInt(facturationInfos.items['invoice']['OVER_PAID'].including_vat_amount) : 0)+(facturationInfos.items['invoice'] && facturationInfos.items['invoice']['NOT_PAID'] ? parseInt(facturationInfos.items['invoice']['NOT_PAID'].including_vat_amount) : 0);
      creditNoteAmount = (facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['REFUNDED'] ? parseInt(facturationInfos.items['credit_note']['REFUNDED'].including_vat_amount) : 0)+(facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['NOT_REFUNDED'] ? parseInt(facturationInfos.items['credit_note']['NOT_REFUNDED'].including_vat_amount) : 0);


      caHorsTva = (facturationInfos.items['invoice'] && facturationInfos.items['invoice']['PAID'] ? parseInt(facturationInfos.items['invoice']['PAID'].excluding_vat_amount) : 0) + (facturationInfos.items['invoice'] && facturationInfos.items['invoice']['OVER_PAID'] ? parseInt(facturationInfos.items['invoice']['OVER_PAID'].excluding_vat_amount) : 0)+ (facturationInfos.items['invoice'] && facturationInfos.items['invoice']['NOT_PAID'] ? parseInt(facturationInfos.items['invoice']['NOT_PAID'].excluding_vat_amount) : 0) - ((facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['REFUNDED'] ? parseInt(facturationInfos.items['credit_note']['REFUNDED'].including_vat_amount) : 0) + (facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['NOT_REFUNDED'] ? parseInt(facturationInfos.items['credit_note']['NOT_REFUNDED'].including_vat_amount) : 0));
      caTvaInclu = invoiceAmount - creditNoteAmount;
      caTva = caTvaInclu - caHorsTva;

    }

    const showDocumentDate = this.props.statisticsFilter.year.length > 0 ? `documentDate=[${this.props.statisticsFilter.year.join(',')}],` : (this.getEventDates().length > 0 ? `documentDate=[${this.getEventDates().join(',')}],` :``);
    const showAppRef = this.props.statisticsFilter.appRefs.length > 0 ? `,appRefs=[${this.props.statisticsFilter.appRefs.join(',')}]` : ``;
    return (
      <div className="fact-bloc">

        <div className="title">
          {_('Facturation')}
        </div>
        <Row gutter={16}>
          <Col className="gutter-row" span={6} xs={20} sm={20} md={12} xl={6}>
            <div className="gutter-box">
              <div className="sub-title-facturation">
                {_('ORDERS')}
              </div>

              <div className="line"/>

              <div className="pt-4 pl-4 flex mt-6">

                <Piechart multi total={totalOrder} count={totalValidOrder} label = {'bdc'} pieColor = {'rgb(109, 127, 146)'}  />
                <div className="flex items-center justify-center flex-col ml-2">
                  <div className="text-center div-total self-auto pr-2">
                    TOTAL
                  </div>
                  <div className="div-amount flex self-end pr-2">
                    {formatAmount(orderAmount)}
                  </div>

                  <div className="valid-order text-center mt-4 flex items-center justify-center">
                    {facturationInfos && facturationInfos.items && facturationInfos.items[0] && facturationInfos.items[0].count ? facturationInfos.items[0].count + ' '+ _('VALID') : 0+ ' '+ _('VALID')}
                  </div>

                  <div className="invalid-order text-center mt-3 flex items-center justify-center">
                    {facturationInfos && facturationInfos.items && facturationInfos.items[1] && facturationInfos.items[1].count ? facturationInfos.items[1].count + ' '+ _('CANCELED') : 0+ ' '+ _('CANCELED')}
                  </div>
                </div>

              </div>
              <div style={{height : "59px !important"}} />
            </div>
          </Col>
          <Col className="gutter-row" span={6} xs={20} sm={20} md={12} xl={6}>
            <div className="gutter-box">
              <div className="sub-title-facturation">
                {_('INVOICES')}
              </div>
              <div className="line"/>
              <div className="pt-4 pl-4 flex mt-6">
                <Piechart total={totalOrder} count={totalInvoices} label = {_('INVOICE')}  pieColor = {'rgb(109, 127, 146)'} style={{opacity:0.1}}/>
                <div className="flex items-center justify-center flex-col">
                  <div className="text-center div-total self-auto pr-2">
                    TOTAL
                  </div>
                  <div className="text-center div-amount flex self-end pr-2">
                    {formatAmount(invoiceAmount)}
                  </div>

                  <div style={{cursor: 'pointer'}} className="valid-order text-center mt-4 flex items-center justify-center">
                    {
                      facturationInfos && facturationInfos.items && facturationInfos.items['invoice']  ? formatAmount((facturationInfos.items['invoice']['PAID'] ? parseInt(facturationInfos.items['invoice']['PAID'].including_vat_amount) : 0) + (facturationInfos.items['invoice']['OVER_PAID'] ? parseInt(facturationInfos.items['invoice']['OVER_PAID'].including_vat_amount) : 0)) + ' '+ _('PAID') : formatAmount(0)+ ' '+ _('PAID')
                    }
                  </div>

                  <div style={{cursor: 'pointer'}} className="invalid-order text-center mt-3 flex items-center justify-center">
                    {
                      facturationInfos && facturationInfos.items && facturationInfos.items['invoice']  ? formatAmount((facturationInfos.items['invoice']['NOT_PAID'] ? parseInt(facturationInfos.items['invoice']['NOT_PAID'].including_vat_amount) : 0)) + ' '+ _('NOT_PAID') : formatAmount(0)+ ' '+ _('NOT_PAID')
                    }
                  </div>

                </div>
              </div>

              <div className='pt-3 btn-reconciliation'>
                <div className="flex mb-4 justify-center">
              <Button  type='default'  data-operation="invoice" onClick={() => this.showModal("invoice")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('Visualiser')}

              </Button>

                </div>
              {this.state.visible && this.state.discr === 'invoice' && <Modal
                visible={this.state.visible && this.state.discr === 'invoice'}
                onCancel={this.handleCancel}
                footer={null}
                width={'97%'}
                style={{ top: 26 }}
              >

                <div className="min-h-full">
                  <DocumentsToBeExportedEfffZipDetails  discriminant = {"invoice"} textPopup = {_("INVOICES")}/>
                </div>
              </Modal>}

              </div>
            </div>
          </Col>
          <Col className="gutter-row" span={6} xs={20} sm={20} md={12} xl={6}>
            <div className="gutter-box">
              <div className="sub-title-facturation">
                {_('CREDIT-NOTES')}
              </div>
              <div className="line"/>
              <div className="flex pt-4 pl-4 mt-6">
                <Piechart total={totalOrder} count={totalCreditNote} label = {'ndc'} pieColor = {'rgb(109, 127, 146)'} style={{opacity:0.1}}/>
                <div className="flex items-center justify-center flex-col ml-2">
                  <div className="text-center div-total self-auto pr-2">
                    TOTAL
                  </div>
                  <div className="text-center div-amount flex self-end pr-2">
                    {formatAmount(creditNoteAmount)}
                  </div>

                  <div className="valid-order text-center mt-4 flex items-center justify-center">
                    {facturationInfos && facturationInfos.items && facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['REFUNDED'] && facturationInfos.items['credit_note']['REFUNDED'].including_vat_amount ? formatAmount(parseInt(facturationInfos.items['credit_note']['REFUNDED'].including_vat_amount)) + ' '+ _('REFUNDED') : formatAmount(0)+ ' '+ _('REFUNDED')}
                  </div>

                  <div className="invalid-order text-center mt-3 flex items-center justify-center">
                    {facturationInfos && facturationInfos.items && facturationInfos.items['credit_note'] && facturationInfos.items['credit_note']['NOT_REFUNDED'] && facturationInfos.items['credit_note']['NOT_REFUNDED'].including_vat_amount ? formatAmount(parseInt(facturationInfos.items['credit_note']['NOT_REFUNDED'].including_vat_amount)) + ' '+ _('to-be-refunded') : formatAmount(0)+ ' '+ _('to-be-refunded')}
                  </div>

                </div>
              </div>

              <div className='pt-3 btn-reconciliation'>
                <div className="flex mb-4 justify-center">
                  <Button  type='default'  data-operation="invoice" onClick={() => this.showModal("credit_note")}>
                  <span className="pr-2">
                    <img src={"/img/icons/SHOW.svg"}/>
                  </span> {_('Visualiser')}

                  </Button>

                </div>
                {this.state.visible && this.state.discr === 'credit_note' && <Modal
                  visible={this.state.visible && this.state.discr === 'credit_note'}
                  onCancel={this.handleCancel}
                  footer={null}
                  width={'97%'}
                  style={{ top: 26 }}
                >

                  <div className="min-h-full">
                    <DocumentsToBeExportedEfffZipDetails  discriminant = {"credit_note"} textPopup = {_("CREDIT-NOTES")}/>
                  </div>
                </Modal>}

              </div>

            </div>
          </Col>
          <Col className="gutter-row" span={6} xs={20} sm={20} md={12} xl={6}>
            <div className="gutter-box">
              <div className="sub-title-facturation">
                {_('CA')}
              </div>
              <div className="line"/>

              <div className="pt-4 pl-4 flex ca-cantainer">
                <div className="flex items-center justify-center ">
                  <img src={"/img/icons/CA-ICON.svg"}/>
                </div>

                <div className="ml-4" >

                  <div className="flex items-center justify-center flex-row">
                    <div className="text-center div-total ca-label-text">
                      HTVA:
                    </div>
                    <div className="text-center div-amount">
                      {formatAmount(caHorsTva)}
                    </div>
                  </div>


                  <div className="flex items-center justify-center flex-row">
                    <div className="text-center div-total ca-label-text">
                      TVA:
                    </div>
                    <div className="text-center div-amount">
                      {formatAmount(caTva)}
                    </div>
                  </div>


                  <div className="flex items-center justify-center flex-row">
                    <div className="text-center div-total ca-label-text">TOTAL:
                    </div>
                    <div className="text-center div-amount">
                      {formatAmount(caTvaInclu)}
                    </div>
                  </div>

                </div>

              </div>

            </div>
          </Col>
        </Row>

      </div>);
  }
}

const mapStateToProps = state => ({
  facturationInfos: state.facturationInfos,
  statisticsFilter: state.filters.statisticsFilter,
  eventStatsFilter: state.filters.eventStatsFilter,
  appRef: state.appRefFilter.items,
  auth: state.auth,
});

const mapDispatchToProps = {
  getFacturationStatistics,
  resetDocumentsFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(FacturationStatisticsBloc);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/FacturationStatisticsBloc.js